<template>
  <div class="busniess-profile">
    <v-container>
      <h3 class="d-block text-center" style="color: #434343; padding: 8px">
      </h3>
      <v-form ref="formBusinessProfile">
        <v-row class="ma-0">
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Description of Service/Goods <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              v-model="business_primary_contact_details.services_or_goods"
              :rules="TextRules"
              maxlength="51"
              color="#434343"
              outlined
              placeholder="Enter Description of Service/Goods"
              label=""
              dense
              name="business_goods_description"
              id="business_goods_description"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Business License <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              v-model="business_primary_contact_details.business_licence"
              :rules="TextRules"
              color="#434343"
              maxlength="51"
              outlined
              placeholder="Enter Business License"
              label="" 
              dense
              name="business_license"
              id="business_license"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">
                      mdi-alert-circle-outline
                    </v-icon>
                  </template>
                  <small 
                    >DO YOU HAVE A BUSINESS LICENSE<br />(IF YES, PLEASE
                    SPECIFY)</small
                  >
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Industries <span class="red--text"><strong>* </strong></span></label>
            <!-- <v-text-field
              v-model="business_primary_contact_details.industries"
              :rules="TextRules"
              color="#434343"
              maxlength="51"
              outlined
              placeholder="Enter "
              label="Industries"
              dense
              name="business_industries"
              id="business_industries"
            > -->

            <v-combobox
              color="#434343"
              v-model="business_primary_contact_details.industries"
              :rules="TextRules"
              clearable
              height="100%"
              multiple
              append-icon="mdi-abc"

              name="business_industries"
              id="business_industries"
              
              outlined
              placeholder="Enter Industries"
            >
              <template
                v-slot:selection="{ attrs, item, select, selected, index }"
                style="padding-top: 10px !important"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  class="my-1 mt-2"
                  small
                  @click="select"
                  @click:close="
                    business_primary_contact_details.industries.splice(index, 1)
                  "
                >
                  <strong>{{ item }}</strong
                  >&nbsp;
                </v-chip>
              </template>
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">
                      mdi-alert-circle-outline
                    </v-icon>
                  </template>
                  <small
                    >PLEASE LIST THE INDUSTRIES THE<br />
                    OTHER ENTITIES DEAL IN</small
                  >
                </v-tooltip>
              </template>
            </v-combobox>
            <blockquote style="text-align: end; margin-top: -26px;"><small style="font-size: 11px;" class="grey--text">Press the enter or tab button to proceed with the enlistings of the industries</small></blockquote>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Websites <span class="red--text"><strong>* </strong></span></label>
            <v-combobox
              color="#434343"
              v-model="business_primary_contact_details.companies_and_websites"
              :rules="websiteRules"
              clearable
              label=""
              multiple
              outlined
              placeholder="Enter Websites"
              append-icon="mdi-abc"
            >
              <template
                v-slot:selection="{ attrs, item, select, selected, index }"
                style="padding-top: 10px !important"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  class="my-1 mt-2"
                  small
                  @click="select"
                  @click:close="
                    business_primary_contact_details.companies_and_websites.splice(
                      index,
                      1
                    )
                  "
                >
                  <strong>{{ item }}</strong
                  >&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <blockquote style="text-align: end; margin-top: -26px;"><small style="font-size: 11px;" class="grey--text">Press the enter or tab button to proceed with the enlistings of the websites</small></blockquote>
          </v-col>
        </v-row>
      </v-form>
      <v-btn
        @click="updateBusinessProfile()"
        class="mb-2 mt-10 float-end next-btn appBlue white--black ml-2"
      >
        Next
      </v-btn>
      <v-btn text @click="updateIndex(4)" class="float-end mb-2 mt-10 mr-1 next-btn liteGray black--text ">
        Previous
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "BusinessProfile",
  data() {
    return {
      search: "",
      searchIndustries: "",
      key: null,
      websiteRules: [
        v => v.length > 0 || "Required",
        v => !!v || "Website is Required",
        v => /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm.test(v) ||
          // /(^http[s]?:\/{2})|(^www.)|(^\/{1,2})/.test(v) ||
          "Pattern should be like website"
      ],
      // TextRules: [v => !!v || "Required"],
      TextRules: [(v) => !!v || "Required"],

      items: [],
      business_primary_contact_details: {
        services_or_goods: "",
        business_licence: "",
        industries: [],
        companies_and_websites: []
      }
    };
  },
  computed: {
    ...mapGetters(["getUserId", "getFormId", "getBusinessPrimaryID"])
  },
  methods: {
    updateItems() {
      if (this.search !== null && this.search !== "") {
        this.$nextTick(() => {
          this.business_primary_contact_details.companies_and_websites.push(
            ...this.search.split(",")
          );
          this.$nextTick(() => {
            this.search = "";
          });
        });
      }
    },
    updateIndustries() {
      if (this.searchIndustries !== null && this.searchIndustries !== "") {
        this.$nextTick(() => {
          this.business_primary_contact_details.industries.push(
            ...this.searchIndustries.split(",")
          );
          this.$nextTick(() => {
            this.searchIndustries = "";
          });
        });
      }
    },
    updateBusinessProfile() {
      if (!this.$refs.formBusinessProfile.validate()) {
        this.$store.dispatch("updateBusinessProfileError", true);
      } else {
        this.$store.dispatch("updateBusinessProfileError", !true);
      }
      axios
        .post(
          "/createBusinessPrimaryContactDetail",
          {
            business_primary_contact_detail: this
              .business_primary_contact_details,
            business_primary_contact_detail_id: this.getBusinessPrimaryID,
            form_id: this.getFormId,
            user_id: this.getUserId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          // console.log(res.data, "business primary");
        })
        .catch(err => {
          console.log(err.response.data, "business error");
        });
      this.updateIndex(6);

      this.$store.dispatch("incrementStepper");
    },
    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    }
  },
  mounted() {
    axios
      .post(
        "/businessPrimaryContactDetail",
        {
          form_id: this.getFormId,
          user_id: this.getUserId
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        // console.log(res.data.businessPrimaryContactDetail, "business primary");
        if (
          res.data.businessPrimaryContactDetail.companies_and_websites == "" ||
          res.data.businessPrimaryContactDetail.companies_and_websites == null
        ) {
          this.business_primary_contact_details.companies_and_websites = "";
        } else {
          JSON.parse(
            res.data.businessPrimaryContactDetail.companies_and_websites
          ).filter(website => {
            this.business_primary_contact_details.companies_and_websites.push(
              website
            );
          });
        }
        this.business_primary_contact_details.services_or_goods =
          res.data.businessPrimaryContactDetail.services_or_goods == null
            ? ""
            : res.data.businessPrimaryContactDetail.services_or_goods;
        this.business_primary_contact_details.business_licence =
          res.data.businessPrimaryContactDetail.business_licence == null
            ? ""
            : res.data.businessPrimaryContactDetail.business_licence;

        if (
          res.data.businessPrimaryContactDetail.industries == "" ||
          res.data.businessPrimaryContactDetail.industries == null
        ) {
          this.business_primary_contact_details.industries = "";
        } else {
          JSON.parse(res.data.businessPrimaryContactDetail.industries).filter(
            industry => {
              this.business_primary_contact_details.industries.push(industry);
            }
          );
        }
      })
      .catch(err => {
        console.log(err, "business err");
      });

    this.TextRules.push(v => v.length <= 100 || "Max 100 characters");
  }
};
</script>

<style scoped>
.v-select__slot {
  padding-top: 10px !important;
}
.adjust-pre-btn {
font-size: 11px !important;
}
</style>
